import React from "react";
import { Link } from "@quintype/components";
import { object, bool, string } from "prop-types";

import { getExcerpt } from "../../utils/utils";

import CardImage from "../../atoms/CardImage";
import StoryMetaData from "../../molecules/StoryMetaData";
import NewsHeadline from "../NewsHeadline";
import Excerpt from "../Excerpt";

import "./relatedStory.m.css";

const RelatedStory = ({ story, isMobile, storyClass, storyType }) => {
  const excerpt = getExcerpt(story);

  return (
    <div styleName="related-story-container" key={story.id}>
      <div>
        <Link aria-label={story.headline} href={story.url} target="_blank">
          <NewsHeadline
            showSubHeading={false}
            linkEnable={false}
            story={story}
            cssStyleName={storyType === "photo" ? "smallSize" : ""}
          />
        </Link>
      </div>
      <div styleName={storyClass} className="related-story">
        {!isMobile && (
          <div className="story-data">
            <Link aria-label={story.headline} href={story.url} target="_blank">
              <Excerpt excerpt={excerpt} linkEnable={false} />
            </Link>
            <StoryMetaData story={story} isAuthor={false} showComments={false} />
          </div>
        )}
        <div>
          <Link aria-label={story.headline} href={story.url} target="_blank">
            <CardImage
              story={story}
              aspectRatio={[3, 2]}
              imageType="image3x2"
              showAlternateImage={true}
              widths={[200]}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

RelatedStory.propTypes = {
  story: object.isRequired,
  isMobile: bool,
  storyClass: string,
  storyType: string,
};

export default RelatedStory;
